import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["changeIntent", "intent", "name"];

  async connect() {
    this.intentListeners = [];
    this.changeIntentTargets.forEach((target) => {
      const intent = target.getAttribute("data-intent");
      const handler = (e) => {
        e.preventDefault();
        this.element.className = this.element.className.replace(
          /\bintent-[^ ]+\b/,
          "",
        );
        this.element.classList.add(`intent-${intent}`);
        this.intentTarget.value = intent;
        if (intent == "create") {
          this.nameTarget.setAttribute("required", true);
          this.nameTarget.focus();
        } else {
          this.nameTarget.removeAttribute("required");
        }
      };
      target.addEventListener("click", handler);
      this.intentListeners.push({ target, handler });
    });
  }

  disconnect() {
    this.intentListeners.forEach(({ target, handler }) => {
      target.removeEventListener("click", handler);
    });
  }
}
